"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reduxLogger = _interopRequireDefault(require("redux-logger"));

var _rootReducer = _interopRequireDefault(require("./rootReducer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var middleware = [_reduxThunk.default];

if (process.env.NODE_ENV === "development") {
  middleware.push(_reduxLogger.default);
}

var allStoreEnhancers = (0, _redux.compose)(_redux.applyMiddleware.apply(void 0, middleware) //window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
var store = (0, _redux.createStore)(_rootReducer.default, {}, allStoreEnhancers);
var _default = store;
exports.default = _default;